import { render, staticRenderFns } from "./PayoutTransDetails.vue?vue&type=template&id=3acf5fbc&scoped=true"
import script from "./PayoutTransDetails.vue?vue&type=script&lang=js"
export * from "./PayoutTransDetails.vue?vue&type=script&lang=js"
import style0 from "./PayoutTransDetails.vue?vue&type=style&index=0&id=3acf5fbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acf5fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3acf5fbc')) {
      api.createRecord('3acf5fbc', component.options)
    } else {
      api.reload('3acf5fbc', component.options)
    }
    module.hot.accept("./PayoutTransDetails.vue?vue&type=template&id=3acf5fbc&scoped=true", function () {
      api.rerender('3acf5fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data-agent/components/PayoutTransDetails.vue"
export default component.exports